import { FC } from 'react';

import { Stub } from 'components';

export const PassStatusStubPage: FC = () => {
  return <Stub isError={false} title="Пропуск создан" subTitle="Если остались вопросы, свяжитесь с поддержкой" />;
};
